import { environment } from 'src/environments/environment'
import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { MetaOption } from './meta-option'
import { MetaOptionSerializer } from './meta-option.serializer'
import { ResourceService } from 'src/app/shared/resource-service'

@Injectable()
export class MetaOptionService extends ResourceService<MetaOption> {
  private url = `${environment.backendApiUrl}/meta-options`

  constructor(
    private http: HttpClient,
    private metaOptionSerializer: MetaOptionSerializer
  ) {
    super(
      http,
      `${environment.backendApiUrl}/meta-options`,
      metaOptionSerializer
    )
  }
}
